/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import {
  CLIENTS,
  CLIENT_SIGNUP,
  CLIENT_PICKUP_REQUEST,
  CLIENT_RESET_PASSWORD,
  AWB_BULK_UPLOAD,
  CLIENT_ORDERS_SEARCH,
  CLIENT_WMS_AUTH_KEY
} from "../constants/url.constant";

import { API } from "../api";

export const GET_CLIENTS = "GET_CLIENTS";
export const GET_CLIENT = "GET_CLIENT";
export const ADD_CLIENT = "ADD_CLIENT";
export const CLIENT_SIGNUP_PAGE = "CLIENT_SIGNUP";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const SEARCH_AWBS = "SEARCH_AWBS";

export const getAWBs = (awb) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${CLIENT_ORDERS_SEARCH}/${awb}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addPickupAWB = (id, orderId) => {
  return async (dispatch) => {
    try {
      const res = await API.post(`${CLIENT_PICKUP_REQUEST}/${id}/orders/${orderId}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removePickupAWB = (id, orderId) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(
        `${CLIENT_PICKUP_REQUEST}/${id}/orders/${orderId}`
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const bulkUploadAwb = (fileData) => {
  return async (dispatch) => {
    try {
      return await API.post(
        `${CLIENT_PICKUP_REQUEST}/${AWB_BULK_UPLOAD}`,
        fileData
      );
    } catch (error) {
      throw error;
    }
  };
};

export const bulkUploadAwbById = (id, fileData) => {
  return async (dispatch) => {
    try {
      return await API.post(
        `${CLIENT_PICKUP_REQUEST}/${id}/upload-awb/bulk`,
        fileData
      );
    } catch (error) {
      throw error;
    }
  };
};

export const getClients = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(CLIENTS, {
        params: params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_CLIENTS,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getClientById = (clientId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${CLIENTS}/${clientId}`);
      dispatch({
        type: GET_CLIENT,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addClient = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(CLIENTS, data);
      dispatch({
        type: ADD_CLIENT,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const clientSignup = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(CLIENT_SIGNUP, data);
      dispatch({
        type: CLIENT_SIGNUP_PAGE,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateClient = (code, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${CLIENTS}/${code}`, body);
      dispatch({ type: UPDATE_CLIENT, payload: { code, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const resetClientPass = (id, body) => {
  return async (dispatch) => {
    try {
      const res = await API.put(
        CLIENT_RESET_PASSWORD.replace("clientId", id),
        body
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeClient = (hubCode) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${CLIENTS}/${hubCode}`);
      dispatch({
        type: DELETE_CLIENT,
        payload: hubCode
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getWMSAuthKey = (clientId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${CLIENT_WMS_AUTH_KEY}/${clientId}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const saveWMSAuthKey = (clientId, key, token) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${CLIENT_WMS_AUTH_KEY}/${clientId}`, { key, token });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const saveOldWMSAuthKey = (clientId, key) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${CLIENT_WMS_AUTH_KEY}/${clientId}`, { key });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getSubClients = () => {
  return async (dispatch) => {
    try {
      const subClients = localStorage.getItem("subClients");
      return JSON.parse(subClients);
    } catch (error) {
      // 
    }
  };
};

export default function reducer(
  state = { clientTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_CLIENTS:
      return {
        ...state,
        clientTableColumns: payload.columns,
        clientTableRows: payload.rows,
        totalRows: payload.count
      };
    case GET_CLIENT:
      return {
        ...state,
        clientDetail: payload
      };
    case ADD_CLIENT:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        clientTableRows: [...state.clientTableRows, { ...payload }]
      };
    case CLIENT_SIGNUP_PAGE:
      return {
        ...state,
        clientDetail: payload
      };
    case DELETE_CLIENT:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        clientTableRows: state.clientTableRows.filter(
          (client) => client.id !== payload
        )
      };
    case UPDATE_CLIENT:
      return {
        ...state,
        clientTableRows: state.clientTableRows.map((client) =>
          client.id === payload.id ? { ...payload } : client
        )
      };
    default:
      return state;
  }
}
